import { Fragment, useEffect, useState } from 'react';
import {
  TMenuConfig,
  MenuItem,
  MenuLink,
  MenuTitle,
  Menu,
} from '@/components/menu';
import { useDemo1Layout } from '../Demo1LayoutProvider';
import { MENU_MEGA } from '@/config';

interface SidebarOptions {
  collapse: boolean; // 'light' or 'dark'
}

interface LayoutOptions {
  sidebar: SidebarOptions;
}

interface Layout {
  options: LayoutOptions;
}

interface Demo1LayoutContext {
  layout: Layout;
  setSidebarCollapse: (value: boolean) => void;
  sidebarMouseLeave: boolean;
  setMegaMenuEnabled: (value: boolean) => void;
}

const MegaMenuInner = () => {
  const [disabled, setDisabled] = useState(true); // Initially set disabled to true
  const { layout, sidebarMouseLeave, setMegaMenuEnabled } =
    useDemo1Layout() as unknown as Demo1LayoutContext;

  // Change disabled state to false after a certain time (e.g., 5 seconds)
  useEffect(() => {
    setDisabled(true);

    const timer = setTimeout(() => {
      setDisabled(false);
    }, 1000); // 1000 milliseconds

    // Cleanup the timer when the component unmounts
    return () => clearTimeout(timer);
  }, [layout.options.sidebar.collapse, sidebarMouseLeave]);

  useEffect(() => {
    setMegaMenuEnabled(true);
  });

  const build = (items: TMenuConfig) => {
    const homeItem = items[0];

    const linkClass =
      'menu-link text-sm text-gray-700 dark:text-white/80 font-medium menu-link-hover:text-primary dark:menu-link-hover:text-blue-400 menu-item-active:text-gray-900 dark:menu-item-active:text-white menu-item-show:text-primary dark:menu-item-show:text-blue-400 menu-item-here:text-gray-900 dark:menu-item-here:text-white contrast:text-white contrast:menu-link-hover:text-white contrast:menu-item-active:text-white contrast:menu-item-show:text-white contrast:menu-item-here:text-white';
    const titleClass = 'text-nowrap';

    return (
      <Fragment>
        <MenuItem key="home">
          <MenuLink path={homeItem.path} className={linkClass}>
            <MenuTitle className={titleClass}>{homeItem.title}</MenuTitle>
          </MenuLink>
        </MenuItem>
      </Fragment>
    );
  };

  return (
    <Menu
      multipleExpand={true}
      disabled={disabled}
      highlight={true}
      className="flex-col lg:flex-row gap-5 lg:gap-7.5 p-5 lg:p-0"
    >
      {build(MENU_MEGA)}
    </Menu>
  );
};

export { MegaMenuInner };
